import React from 'react';

import butterflyIcon from './assets/butterfly.svg';

import './styles.css';

const EmptyListPlaceholder = () => (
  <div className="EmptyListPlaceholder colab-centered">
    <div className="colab-centered">
      <div className="colab-sidepadding-1">
        <img src={butterflyIcon} />
      </div>
      <div className="EmptyListPlaceholder__message colab-bold">
        Nothing here yet...
      </div>
    </div>
  </div>
);

export default EmptyListPlaceholder;
